import { useWeb3React } from "@web3-react/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import Environment from "../../utils/Environment";
import useWeb3 from "../useWeb3";
import { getVestingContract } from "../../utils/contractHelpers";
import Web3 from "web3";

const useGetVestingInfo = (amount, user) => {
  // const web3 = useWeb3();
  const [vestingInfo, setVestingInfo] = useState(null);

  const web3 = useMemo(
    () =>
      new Web3("https://arb-mainnet.g.alchemy.com/v2/m1ZDZF0NDLbqkK-we12g0"),
    []
  );

  const vestingContractInstance = useMemo(() => {
    if (!web3) return null;
    return getVestingContract(Environment.Vesting, web3);
  }, [web3]);

  const getVestingInfo = useCallback(async () => {
    if (!vestingContractInstance || !amount || !user) return "0";
    try {
      const info = await vestingContractInstance.methods
        .getCycleInfo(amount)
        .call();
      setVestingInfo(info);
      // console.log("vestingInfo: ", info);
    } catch (error) {
      console.error("Error fetching vestingInfo", error);
      // throw error;
    }
  }, [vestingContractInstance, amount]);

  useEffect(() => {
    if (!amount || !user) return;

    getVestingInfo(); // initial fetch

    const interval = setInterval(() => {
      getVestingInfo();
    }, 5000);

    return () => clearInterval(interval);
  }, [getVestingInfo, amount, user]);

  return { vestingInfo, refetchVestingInfo: getVestingInfo };
};

export default useGetVestingInfo;
